/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Splide from '@splidejs/splide';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import 'bs5-lightbox'

import './custom'

var options = {
  type: 'loop',
  perPage: 3,
  perMove: 1,
  pagination: false,
  gap: '85px',
  arrows: false,
  breakpoints: {
    767: {
      perPage: 1,
    }
  }
};

var roomOptions = {
  perPage: 2.5,
  perMove: 1,
  focus: 'center',
  gap: '85px',
  arrows: false,
  breakpoints: {
    767: {
      perPage: 1
    },
    1200: {
      gap: '25px'
    }
  }
};

var optionsActivity = {
  type: 'loop',
  perPage: 3,
  perMove: 1,
  gap: '2px',
  arrows: false,
  breakpoints: {
    767: {
      perPage: 1
    }
  }
};

var optionsTrip = {
  type: 'loop',
  perPage: 1,
  perMove: 1,
  arrows: false,
};

var optionsBlock = {
  type: 'loop',
  perPage: 3.5,
  perMove: 1,
  arrows: false,
  breakpoints: {
    768: {
      perPage: 1,
      perMove: 1
    }
  }
};

var offerLongShortOptions = {
  perPage: 3,
  perMove: 1,
  gap: '85px',
  //focus: 'center',
  //loop: true,
  //pagination: false,
  arrows: true,
  breakpoints: {
    767: {
      perPage: 1,
      perMove: 1
    }
  }
};

var reviewOptions = {
  perPage: 1,
  perMove: 1,
  focus: 'center',
  arrows: false
};

var homeActivityImagesOptions = {
  perPage: 1,
  cover: true,
  heightRatio: 1,
  loop: true,
  gap: '8px',
  perMove: 1,
  focus: 'center',
  arrows: false
};

let postOptions = offerLongShortOptions;

function initializeRoomSplide() {
  new Splide(
    '#room-slider',
    roomOptions
  ).mount();
}

function initializeOfferSlider() {
  new Splide(
    '#offer-slider',
    options
  ).mount();
}

function initializeOfferSliderAll() {
  if ($('#offer-slider-all').length > 0) {
    new Splide(
      '#offer-slider-all',
      offerLongShortOptions
    ).mount();
  }
}

function initializePostSlider() {
  if ($('#post-slider').length > 0) {
    new Splide(
      '#post-slider',
      postOptions
    ).mount();
  }
}

function initializeOfferSliderLong() {
  if (!$('#offer-slider-long').hasClass('splide--slide')) {
    new Splide(
      '#offer-slider-long',
      offerLongShortOptions
    ).mount();
  }
}

function initializeOfferSliderShort() {
  if (!$('#offer-slider-short').hasClass('splide--slide')) {
    new Splide(
      '#offer-slider-short',
      offerLongShortOptions
    ).mount();
  }
}

function initiaizeActivityGallerySlider() {
  new Splide(
    '#activity-gallery',
    optionsActivity
  ).mount();
}

function initiaizeTripActivityGallerySlider() {

  $('.trip-gallery').each(function () {
    new Splide(
      '#' + this.id,
      optionsTrip
    ).mount();
  });
}

function initiaizeBlockSlider() {

  $('.block-slider').each(function () {
    new Splide(
      '#' + this.id,
      optionsBlock
    ).mount();
  });
}

function initializeReviewSlider() {
  new Splide(
    '#review-slider',
    reviewOptions
  ).mount();
}

function initializeHomeWinterActivityImageSlider() {
  new Splide(
    '#home-winter-activity-images-slider',
    homeActivityImagesOptions
  ).mount();
}

function initializeHomeSummerActivityImageSlider() {
  new Splide(
    '#home-summer-activity-images-slider',
    homeActivityImagesOptions
  ).mount();
}

function initAOS() {
  AOS.init({
    duration: 550,
    delay: 50,
    easing: 'ease-out'
  });
}
function deafultAOS() {
  /*$('.horizontal-line-left').not('.horizontal-line-right').attr('data-aos', 'fade-right');
  $('.horizontal-line-right').not('.horizontal-line-left').attr('data-aos', 'fade-left');
  $('.horizontal-line-right.horizontal-line-left').attr('data-aos', 'fade-up');

  $('h3').attr('data-aos', 'fade-up');
*/
  $('.winter-content img, .summer-content img, img.winter-content, img.summer-content').attr('data-aos', 'zoom-in');
  $('.gallery-page img').attr('data-aos', 'fade-in');
  var $containers = $('.container, .container-fluid, .container-genzianella, .container-offer, .container-activity, .container-lets-bike, .row, .col');
  $containers.each(function( index ) {
    var $elem = $(this);
    if ($elem.closest('.always-show').length === 0) {
      $elem.attr('data-aos', 'fade-in');
    }
  });
}

let scrollRef = 0;

window.addEventListener('scroll', function() {
  // increase value up to 10, then refresh AOS
  scrollRef <= 10 ? scrollRef++ : AOS.refresh();
});

$(() => {

  if ($('#room-slider').length > 0) {
    initializeRoomSplide();
  }

  if ($('#offer-slider').length > 0) {
    initializeOfferSlider();
  }

  if ($('#offer-slider-long').length > 0) {
    initializeOfferSliderLong();
  }

  if ($('#offer-slider-all').length > 0) {
    initializeOfferSliderAll();
  }

  if ($('#post-slider').length > 0) {
    initializePostSlider();
  }

  if ($('#offer-slider-short').length > 0) {
    initializeOfferSliderShort();
  }

  if ($('#activity-gallery').length > 0) {
    initiaizeActivityGallerySlider();
  }

  if ($('.trip-gallery').length > 0) {
    initiaizeTripActivityGallerySlider();
  }

  if ($('.block-slider').length > 0) {
    initiaizeBlockSlider();
  }

  if ($('#review-slider').length > 0) {
    initializeReviewSlider();
  }

  if ($('#home-winter-activity-images-slider').length > 0) {
    initializeHomeWinterActivityImageSlider();
  }

  if ($('#home-summer-activity-images-slider').length > 0) {
    initializeHomeSummerActivityImageSlider();
  }


  deafultAOS();
  initAOS();


  $('.navbar-collapse').on('hide.bs.collapse', function () {
    $('.navbar-toggler').removeClass('active');
    $('.navbar-toggler i:first-child').show();
  });

  $('.navbar-collapse').on('shown.bs.collapse', function () {
    $('.navbar-toggler').addClass('active');
    $('.navbar-toggler i:first-child').hide();

    //fix height of right shop menu
    if($( window ).width() >= 768) {
      let htmlLang = $('html').attr('lang');
      console.log('lang2', htmlLang);

      let spacing = '';
      if (htmlLang === 'it-IT') {
        spacing = $('#menu-item-71').offset().top - $('#menu-item-77').offset().top - $('#menu-item-77').height();
      } else {
        spacing = $('#menu-item-1392').offset().top - $('#menu-item-1391').offset().top - $('#menu-item-1391').height();
      }

      console.log('spacing', spacing);

      let rightMenuItems = document.querySelectorAll('.menu-right-shop-container li:not(:last-child)');
      for(let item of rightMenuItems) {
        console.log('found', item);
        if(item.nextElementSibling) {
          item.style.paddingBottom = '' + spacing + 'px';
        }
      }

      // if (htmlLang == 'it-IT') {
      //   var spacing = $('#menu-item-71').offset().top - $('#menu-item-77').offset().top - $('#menu-item-77').height();
      //   $('#menu-item-1275').css('padding-bottom', spacing + 'px');
      //   $('#menu-item-1276').css('padding-bottom', spacing + 'px');
      //   $('#menu-item-2189').css('padding-bottom', spacing + 'px');
      // } else {
      //   var spacing = $('#menu-item-1392').offset().top - $('#menu-item-1391').offset().top - $('#menu-item-1391').height();
      //   $('#menu-item-1403').css('padding-bottom', spacing + 'px');
      //   $('#menu-item-1404').css('padding-bottom', spacing + 'px');
      // }
    }

  });

  $('[data-slider-container="offer-duration-long-container"]').on('click', function () {
    initializeOfferSliderLong();
  });

  $('[data-slider-container="offer-duration-short-container"]').on('click', function () {
    initializeOfferSliderShort();
  });
});




